import { render, staticRenderFns } from "./zdjTabs.vue?vue&type=template&id=bf38f360&scoped=true"
import script from "./zdjTabs.vue?vue&type=script&lang=js"
export * from "./zdjTabs.vue?vue&type=script&lang=js"
import style0 from "./zdjTabs.vue?vue&type=style&index=0&id=bf38f360&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf38f360",
  null
  
)

export default component.exports